<template>
  <div>
    <v-app-bar app color="grey darken-4" dark flat dense>
      <v-app-bar-nav-icon
        @click="mini = !mini"
        v-if="authUser ? true : false"
      />

      <div class="align-center" style="user-select: none">
        <router-link
          :to="{ name: 'Home' }"
          style="text-decoration: none; color: inherit;"
        >
          <span class="font-weight-medium text-h4 texto-cinza-claro">mega</span>
          <span class="font-weight-bold text-h4 texto-vermelho-escuro"
            >bit</span
          >
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        class="align-center"
        style="user-select: none"
        v-if="enableSystemButton && currentSystem && currentSystem.CODIGO > 0"
        @click.prevent="showFiliais()"
      >
        <span
          class="font-weight-medium text-h6 texto-cinza-claro text-truncate"
          v-if="$vuetify.breakpoint.name !== 'xs'"
        >
          {{
            currentSystem.NOME.length > allowedLength
              ? `${currentSystem.NOME.substr(0, allowedLength) + '...'}`
              : currentSystem.NOME
          }}
          [ {{ currentSystem.CODIGO }} ]
        </span>
        <span class="font-weight-medium text-h6 texto-cinza-claro" v-else>
          [ {{ currentSystem.CODIGO }} ]
        </span>
      </v-btn>
      <v-spacer></v-spacer>

      <div class="text-center" v-if="authUser.CODIGO != null">
        <v-menu bottom transition="scale-transition" dark app>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <span class="font-weight-bold white--text">
                {{ authUser.NOME }}
              </span>
              <v-icon right>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-if="enableSystemButton"
              @click.prevent="showFiliais()"
            >
              <v-list-item-icon>
                <v-icon>mdi-home-search-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="font-weight-bold">{{
                    $t('labels.filial')
                  }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.prevent="logout()">
              <v-list-item-icon>
                <v-icon color="red darken-4">mdi-power</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="texto-vermelho-escuro font-weight-black">{{
                    $t('labels.logout').toUpperCase()
                  }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <language-select
          ref="languageSelect"
          v-if="authUser"
          :currentLanguage="localLanguage"
          @languageChanged="changeLanguage($event)"
        />
      </div>
    </v-app-bar>

    <v-navigation-drawer
      app
      v-model="navigationDrawer"
      color="grey darken-4"
      v-if="authUser && !tokenIsInvalid"
      :mini-variant.sync="mini"
      :permanent="permanent"
      :mini-variant-width="70"
      height="100%"
    >
      <v-list-item dark>
        <v-list-item-avatar @click="mini = !mini">
          <v-img contain src="logo.ico"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="title font-weight-thin">
            Menu
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list nav dark>
        <v-list-item
          v-for="item in sidebarItems"
          :key="item.title"
          :to="{ name: item.name }"
          @shortkey="
            $route.name !== item.name ? $router.push({ name: item.name }) : ''
          "
          v-shortkey.once="item.title == 'Sistema' ? ['alt', 's'] : undefined"
          link
          @mouseover="toogleTooltip('over')"
          @mouseleave="toogleTooltip('leave')"
        >
          <v-tooltip :disabled="!showTooltip" top>
            <template v-slot:activator="{ on, attrs }" :value="showTooltip">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  >{{ $t(`menu-home.${item.name.toLowerCase()}`) }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <span>{{ $t(`menu-home.${item.name.toLowerCase()}`) }}</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <system-select
      ref="systemSelect"
      v-model="openSystemSelect"
      v-if="authUser"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { routes } from '@/router/index'
import SystemSelect from '@/components/object/system/Select'
import LanguageSelect from '@/components/unique/home/Select-Language'

export default {
  components: {
    SystemSelect,
    LanguageSelect,
  },
  data: () => {
    return {
      openSystemSelect: false,
      navigationDrawer: false,
      mini: true,
      showTooltip: false,
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'authModule/getAuthUser',
      currentSystem: 'systemModule/getCurrentSystem',
    }),
    ...mapState('authModule', ['tokenInvalid']),
    permanent: {
      get() {
        return this.$vuetify.breakpoint.name != 'xs' || this.mini ? true : false
      },
    },
    tokenIsInvalid() {
      return this.tokenInvalid
    },
    allowedLength() {
      var allowed = this.currentSystem.NOME.length
      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
          allowed = 15
          break
        case 'md':
          allowed = 25
          break
        case 'lg':
          allowed = 75
          break

        default:
          break
      }

      return allowed
    },
    enableSystemButton() {
      return this.authUser && !this.authUser.guest
    },

    localLanguage() {
      let usersLang = JSON.parse(localStorage.getItem('usersLang'))

      if (usersLang && usersLang.length > 0) {
        let user = usersLang.filter(
          (element) => element.user == this.authUser.NOME
        )

        if (user && user.length > 0) this.switchLocale(user[0].lang)
      }
      return this.$i18n.locale
    },

    sidebarItems() {
      if (this.authUser.guest != null)
        return [
          {
            title: 'Página Inicial',
            icon: 'mdi-home-variant',
            name: 'Home',
          },
          { title: 'PDV', icon: 'mdi-cart', name: 'PDV' },
        ]
      else
        return routes
          .filter((route) => {
            return route.show
          })
          .sort((a, b) => {
            if (a.name != 'Home' && b.name != 'Home') {
              if (a.title > b.title) return 1
              else if (a.title < b.title) return -1
              else return 0
            }
          })
    },
  },
  methods: {
    ...mapActions({
      logoutUser: 'authModule/logoutUser',
    }),
    toogleTooltip(type) {
      if (!this.mini) return false
      if (type == 'over') this.showTooltip = true
      else this.showTooltip = false
    },
    async logout() {
      try {
        await this.logoutUser()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        await this.$router.push({ name: 'Login' })
      }
    },
    async showFiliais() {
      try {
        if (!this.enableSystemButton) return

        if (this.$route.name !== 'Home')
          throw new Error(this.$t('messages.redirectToHome'))
        await this.$refs.systemSelect.open()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale
      }
      if (this.$vuetify.lang.current !== locale) {
        this.$vuetify.lang.current = locale
      }
    },

    changeLanguage(event) {
      this.switchLocale(event)

      if (!this.authUser) return

      let usersLang = localStorage.getItem('usersLang')
        ? JSON.parse(localStorage.getItem('usersLang'))
        : []

      if (usersLang.length > 0) {
        usersLang.map((element) => {
          if (element.user == this.authUser.NOME) element.lang = event
          return element
        })
      } else {
        usersLang.push({ user: this.authUser.NOME, lang: event })
      }

      localStorage.setItem('usersLang', JSON.stringify(usersLang))
    },

    // async startListen() {
    //   await this.stopListen()
    //   if (!this.enableSystemButton) return

    //   try {
    //     /**
    //      * Vai ouvir canal com o IDMERCHANT da integração
    //      * ifood.e200ce1c-1cba-4268-8506-5dbbf9abfafa
    //      */
    //     this.userChannel = `ifood.e200ce1c-1cba-4268-8506-5dbbf9abfafa`
    //     console.log('vou começar ouvir', this.userChannel)

    //     window.Echo.channel(this.userChannel).listen(
    //       '.IfoodPolling',
    //       async (e) => {
    //         this.$toasted.info(`iFood Polling ${e.data}`, { duration: 10000 })
    //       }
    //     )
    //   } catch (error) {
    //     this.$toasted.error(error, { duration: null })
    //   }
    // },

    // async stopListen() {
    //   if (this.userChannel) {
    //     await window.Echo.leaveChannel(this.userChannel)
    //     this.userChannel = null
    //   }
    // },
  },

  created() {
    // deixar aqui apenas, pois sempre q muda é verificado e evita deixar escutando
    // this.startListen()
  },
}
</script>
<style>
.texto-vermelho-escuro {
  color: #b71c1c;
}
.texto-cinza-claro {
  color: #eeeeee;
}
</style>
